import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import MobileStickyCTA from "@/components/layout/MobileStickyCTA";
import { useSettings } from "@/context/SettingsContext";

export default function PublicLayout({ children }) {
  const { settings } = useSettings();
  const ann = settings?.announcement;
  return (
    <div className="min-h-screen flex flex-col">
      {ann?.enabled && ann?.text && (
        <div className="bg-primary text-white text-center text-sm py-2 px-4" data-testid="announcement-bar">{ann.text}</div>
      )}
      <Navbar />
      <main className="flex-1 pt-16 pb-20 lg:pb-0">{children}</main>
      <Footer />
      <WhatsAppButton />
      <MobileStickyCTA />
    </div>
  );
}
